import { useTranslation } from "react-i18next";
import { Paragraph } from "@datagame/ui";
import { Bar, BarChart, ResponsiveContainer, Tooltip, type TooltipProps, XAxis, YAxis, Legend } from "recharts";

import { ChartData } from "../RankifierChart";

import styles from "./PositivesVsNegativesChart.module.scss";

const CustomTooltipPositives = ({ active, payload, label }: TooltipProps<number, string>) => {
  const { t } = useTranslation();

  if (active && payload && payload.length) {
    return (
      <div className={styles.tooltipWrapper}>
        <div className={styles.tooltip}>
          <Paragraph size="small" weight="font-bold">
            {label}
          </Paragraph>
          <Paragraph color="secondary">
            {t("report:rankifier.pluses", { count: payload[0].payload.positives })}
          </Paragraph>
          <Paragraph color="secondary">
            {t("report:rankifier.minuses", { count: payload[0].payload.negatives })}
          </Paragraph>
        </div>
      </div>
    );
  }

  return null;
};

export const PositivesVsNegativesChart = ({ data }: { data: ChartData[] }) => {
  const renderLegend = (value: string) => {
    return (
      <Paragraph size="small" color="secondary" weight="font-bold" className={styles.legendItem}>
        {value}
      </Paragraph>
    );
  };
  return (
    <ResponsiveContainer width="100%" height="100%" minHeight={400}>
      <BarChart
        layout="vertical"
        width={500}
        height={400}
        data={data}
        margin={{
          top: 5,
          right: 30,
          left: 20,
          bottom: 5,
        }}
      >
        <XAxis type="number" tick={{ fontSize: "14px", color: "#4E4F4B" }} tickLine={false} orientation="top" />
        <YAxis
          width={200}
          type="category"
          dataKey="name"
          tick={{ fontSize: "14px", color: "#4E4F4B" }}
          tickLine={false}
        />

        <Legend height={36} verticalAlign="top" iconSize={24} formatter={renderLegend} />

        <Tooltip content={<CustomTooltipPositives />} cursor={{ fill: "#E8E8E8" }} />

        <Bar dataKey="negatives" fill="#4E4F4B" stackId="a" />
        <Bar dataKey="positives" fill="#F6A16F" stackId="a" />
      </BarChart>
    </ResponsiveContainer>
  );
};
